import { JSONSchema, JSONSchemaDefinition } from "../../sg-schema/RJSF";


/**
 * Loops trough each schema property
 * @param properties 
 * @param invoke 
 * @param pathBase 
 */
export const forEachSchemaProp = (
    properties: JSONSchema,
    invoke: (path: string, prop: JSONSchemaDefinition) => void,
    pathBase?: string
) => {
    if (!properties) { return };

    Object.keys(properties).forEach((key) => {
        //@ts-ignore
        const prop = properties[key];
        if (prop === true || prop === false) { return };

        if (prop.type === "object") {
            forEachSchemaProp(prop.properties, invoke, key);
            return
        }

        const path = pathBase ? [pathBase, key].join(".") : key;
        invoke(path, prop);
    });
};
